export const supportsSmoothScrollingFunc = () => {
  const body = document && document.body;
  const scrollSave = body.style.scrollBehavior;
  body.style.scrollBehavior = "smooth";
  const hasSmooth = getComputedStyle(body).scrollBehavior === "smooth";
  body.style.scrollBehavior = scrollSave;
  return hasSmooth;
};
export const smoothVerticalScrolling = (element, time, position) => {
  const eTop = element.getBoundingClientRect().top;
  let eAmt, timePart, curTime = 0;

  if (Math.abs(eTop) <= 100) {
    eAmt = eTop / Math.abs(eTop);
    timePart = Math.round(time / Math.abs(eTop));
    while (curTime < time) {
      window && window.setTimeout(SVS_B, curTime, eAmt, position);
      curTime += timePart;
    }
  } else {
    eAmt = Math.round(eTop / 100);
    timePart = time / 100;

    window && window.setTimeout(SVS_B, curTime, eTop - Math.round(eTop / 100) * 100, position);
    curTime += timePart;

    while (curTime < (time + timePart)) {
      window && window.setTimeout(SVS_B, curTime, eAmt, position);
      curTime += timePart;
    }
  }
};
const SVS_B = (eAmt, position) => {
  if (position === "center" || position === "")
    window && window.scrollBy(0, eAmt / 2);
  if (position === "top")
    window && window.scrollBy(0, eAmt);
};

export const smoothScrolling = (element) => {
  const supportsSmoothScrolling = supportsSmoothScrollingFunc();
  if (supportsSmoothScrolling) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  } else {
    smoothVerticalScrolling(element, 300, "top");
  }
};
